import { useState } from "react";
import { useApi } from "../../utils/api/useApi";
import { NewPasswordDto } from "../../models/NewPasswordDto";
import { changePasswordEndpoint } from "../../utils/api/urls";

export const useResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { post } = useApi<void>();

  const resetPassword = async (newPassword: NewPasswordDto) => {
    setLoading(true);
    setError(null);

    try {
      await post(
        changePasswordEndpoint,
        {
          email: newPassword.email,
          password: newPassword.password,
          language: newPassword.language
        },
        { headers: { "X-Kamstrup-WorkflowId": newPassword.workflowId } }
      );
    } catch (err: any) {
      const responseData = err.response?.data as ProblemDetails;

      if (responseData?.errors) {
        throw responseData.errors as BackendErrorDetail[];
      }

      const msg = err.message || "Failed to reset password";

      setError(msg);

      throw [{ code: "error_reset_password", message: msg }];
    } finally {
      setLoading(false);
    }
  };

  return { resetPassword, loading, error };
};
